import { render, staticRenderFns } from "./EstateAdministrationCostCalculatorContainer.vue?vue&type=template&id=080ec5d3"
import script from "./EstateAdministrationCostCalculatorContainer.vue?vue&type=script&lang=js"
export * from "./EstateAdministrationCostCalculatorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports